import React from 'react';
import { Tab, Tabs } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import PageShell from './components/PageShell';
import UsageLogsTab from './tabs/UsageLogsTab';
import NotificationsTab from './tabs/NotificationsTab';
import AuditTab from './tabs/AuditTab';

const TAB_KEYS = ['usage', 'notifications', 'audit'];

export default function OperationsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab') || 'usage';
  const tabIndex = Math.max(0, TAB_KEYS.indexOf(tabParam));

  const handleTab = (_, index) => {
    setSearchParams({ tab: TAB_KEYS[index] });
  };

  return (
    <PageShell
      title={`Step ${tabIndex === 1 ? 9 : tabIndex === 2 ? 10 : 7} — Operations`}
      subtitle="Usage logs · notification logs · audit trail"
    >
      <Tabs value={tabIndex} onChange={handleTab} sx={{ mb: 2 }}>
        <Tab label="Usage logs" />
        <Tab label="Notifications" />
        <Tab label="Audit" />
      </Tabs>

      {tabIndex === 0 && <UsageLogsTab />}
      {tabIndex === 1 && <NotificationsTab />}
      {tabIndex === 2 && <AuditTab />}
    </PageShell>
  );
}
